import { getPbsAPAC, getPbsEU, getPbsUS } from '~/src/dash/resellers/utils/importResellerConfig';

export function parseEndpointURL(url: string): { [key: string]: string } {
  const endpointMap: { [key: string]: string } = {};
  const endpointURL = '/v1/s2s-hb?';
  let pbsEndpoint = '';
  const pbsEndpointUSURL = getPbsUS() + endpointURL;
  const pbsEndpointEUURL = getPbsEU() + endpointURL;
  const pbsEndpointAPACURL = getPbsAPAC() + endpointURL;

  if (url.indexOf(pbsEndpointUSURL) > -1) {
    pbsEndpoint = pbsEndpointUSURL;
  } else if (url.indexOf(pbsEndpointEUURL) > -1) {
    pbsEndpoint = pbsEndpointEUURL;
  } else if (url.indexOf(pbsEndpointAPACURL) > -1) {
    pbsEndpoint = pbsEndpointAPACURL;
  }

  (url.split(pbsEndpoint)[1] || '').split('&').forEach((kv: string) => {
    const kvpair = kv.split('=');
    endpointMap[kvpair[0]] = kvpair[1];
  });

  ['site_id'].forEach((key: string) => {
    if (key in endpointMap) {
      delete endpointMap[key];
    }
  });

  return endpointMap;
}

export function parseInventoryRouteEndpointURL(url: string): { [key: string]: string } {
  const endpointMap: { [key: string]: string } = {};
  const endpointURL = '/v1/inventory_route?';
  let pbsEndpoint = '';
  const pbsEndpointUSURL = getPbsUS() + endpointURL;
  const pbsEndpointEUURL = getPbsEU() + endpointURL;
  const pbsEndpointAPACURL = getPbsAPAC() + endpointURL;

  if (url.indexOf(pbsEndpointUSURL) > -1) {
    pbsEndpoint = pbsEndpointUSURL;
  } else if (url.indexOf(pbsEndpointEUURL) > -1) {
    pbsEndpoint = pbsEndpointEUURL;
  } else if (url.indexOf(pbsEndpointAPACURL) > -1) {
    pbsEndpoint = pbsEndpointAPACURL;
  }

  (url.split(pbsEndpoint)[1] || '').split('&').forEach((kv: string) => {
    const kvpair = kv.split('=');
    endpointMap[kvpair[0]] = kvpair[1];
  });

  ['inventory_route_id'].forEach((key: string) => {
    if (key in endpointMap) {
      delete endpointMap[key];
    }
  });

  return endpointMap;
}
